import parsePhoneNumber from 'libphonenumber-js';
import { BnModalMixin } from '../common/bn-modal-mixin';
import { html, LitEntity, renderIf } from '../utility/lit-entity';
import '../common/bn-loading';
import './props/user-statistics';
import './props/user-permissions-table';
import './actions/delete-user';

class UserSummaryModal extends BnModalMixin(LitEntity) {
  constructor() {
    super();
    this.id = 'user-summary-modal';
  }

  static get properties() {
    return {
      statisticsEntity: { type: Object, attribute: false },
    };
  }

  renderContents() {
    const { name, email, mobile } = this.entity.properties;
    const metricsEntity = this.entity.getSubEntityByClasses(['preferences', 'metrics']);
    const statisticsLink = this.entity.getSubEntityByRel('https://api.binsentry.com/rel/statistics');
    const parsedMobile = parsePhoneNumber(mobile || '');

    return html`
      <style>
        bn-modal#user-summary-modal {
          --modal-min-width: 80%;
          --modal-max-width: 80%;
          --modal-margin: 9px;
          --modal-body-overflow-y: auto;
          --modal-body-background: var(--gray-10);
        }

        bn-modal#user-summary-modal bn-surface {
          max-width: 40em;
          flex-grow: 1;
        }

        bn-modal#user-summary-modal .user-summary-container {
          display: flex;
          flex-wrap: wrap;
        }

        bn-modal#user-summary-modal bn-property[stacked] {
          margin-left: 1em;
        }

        bn-modal#user-summary-modal bn-property {
          --align-value: right;
        }

        bn-modal#user-summary-modal delete-user {
          margin: 0 0 0.5em 0.5em;
        }

        bn-modal#user-summary-modal .properties {
          display: flex;
          flex-wrap: wrap;
          font-size: larger;
          margin-bottom: 1em;
        }
      </style>

      <lit-entity .href="${statisticsLink?.href}" @update="${this._onStatisticsEntityUpdate}"></lit-entity>

      <h3 slot="title">User Summary</h3>

      <div class="properties">
        <bn-property stacked label="Name">${name}</bn-property>
        <bn-property stacked label="Email">${email}</bn-property>
        <bn-property stacked label="Phone">${parsedMobile ? parsedMobile.formatInternational() : mobile}</bn-property>
      </div>

      <div class="user-summary-container">
        ${renderIf(this.statisticsEntity?.hasSubEntityByRel('https://api.binsentry.com/rel/posthog-person'), () => html`
          <bn-surface>
            <user-statistics .href="${statisticsLink.href}"></user-statistics>
          </bn-surface>
        `)}

        ${renderIf(metricsEntity.hasAction('update-preferences', () => html`
          <bn-surface>
            <h3>Metric Preferences</h3>
            ${metricsEntity.getAction('update-preferences').fields.map((field) => html`
              <bn-property label="${field.title}">${field.value.find((v) => v.checked).title}</bn-property>
            `)}
          </bn-surface>
        `))}

        <bn-surface>
          <h3>Permissions</h3>
          <user-permissions-table href="${this.href}"></user-permissions-table>
        </bn-surface>
      </div>
      <delete-user
        buttonstyle='outlinedError'
        .href="${this.href}"
        @response="${this._onResponse}"
      ></delete-user>
    `;
  }

  _onResponse() {
    this.dispatchEvent(new CustomEvent('user-deleted', { bubbles: true, composed: true }));
    this.close();
  }

  _onStatisticsEntityUpdate(e) {
    this.statisticsEntity = e.detail.entity;
  }

  open() {
    this.hide = false;
  }
}

window.customElements.define('user-summary-modal', UserSummaryModal);
